/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Input from "components/Input";
import { useForm, FormProvider, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import apiService from "services/apiService";
import moment from "moment";
import monthData from "./newData";
import { getEpochTime, inUtc } from "util/epochTime";
import { sortByKey } from "util/sortOptions";
import { useToaster } from "contexts/toasterContext";
import { customSelectStyles } from "util/selectStyles";
import { validateNoLeadingTrailingWhitespace } from "util/validation";
import { mergeProjectIds } from "util/projectIds";

const validationSchema = yup.object({
  projects: yup.string().required("Project required"),
  date: yup.string().required("Date is required"),
  Hours: yup
    .number()
    .typeError("Hours must be a number")
    .positive("Hours must be greater than zero")
    .required("Hours is required")
    .max(15, "Hours must be 15 or less"),
 task: yup.string()
     .required("Task is required")
     .test(
       "not-only-spaces",
       "Task cannot be empty spaces", // Updated error message
       validateNoLeadingTrailingWhitespace
     )
     .max(1000, "Project Details cannot be more than 1000 characters"),
});

interface IProps {
  projects: Array<any>;
  selectedProj: any;
  selectedUser: any;
  month: string;
  year: string;
  onClose: () => void;
  wholeData: any;
  setRefresh: any;
  refresh: number;
  selectedDate: any;
  taskId: any;
}

const EditTimeSheet = ({
  projects,
  selectedProj,
  selectedUser,
  month,
  year,
  onClose,
  wholeData,
  setRefresh,
  refresh,
  selectedDate,
  taskId,
}: IProps) => {
  const [selectedProject, setSelectedProject] = useState<string | null>(
    selectedProj
  );
  const [date, setDate] = useState<any>();
  // const [task, setTask] = useState("");
  // const [hour, setHour] = useState(0);
  const { addToast } = useToaster();

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    formState: { isDirty, isSubmitting },
  } = methods;

  useEffect(() => {
    console.log("taskId useEffect", taskId);
    if (!taskId) {
      console.log("No taskId provided, skipping initialization");
      return;
    }
    console.log("taskId.start", taskId.start);

    if (!taskId.start) {
      console.warn("taskId.start is undefined or null");
      return;
    }

    // Validate that taskId.start is a valid date
    const startDate = moment(taskId.start);
    if (!startDate.isValid()) {
      console.error("taskId.start is not a valid date:", taskId.start);
      return;
    }

    const newdate = startDate.format("YYYY-MM-DD");
    const initialProject = taskId.projectId ?? selectedProj ?? "";

    setDate(newdate);
    setSelectedProject(initialProject);

    // Reset establishes loaded values as clean baseline (isDirty=false on open).
    methods.reset({
      date: newdate,
      task: taskId.title || "",
      Hours: taskId.hour || 0,
      projects: initialProject,
    });
  }, [taskId, methods]);
  const TempPro: { value: any; label: any }[] =
    projects && projects.length > 0
      ? projects.map((project: any) => ({
          value: project.projectId,
          label: project.name,
        }))
      : [];
  const projectOptions = sortByKey(TempPro, "label");

  const handleProjectChange = (selectedOption: any) => {
    const nextProject = selectedOption?.value ?? "";
    const currentProject = methods.getValues("projects");
    const hasChanged = String(nextProject) !== String(currentProject ?? "");

    console.log("selectedOption.value", nextProject);
    setSelectedProject(nextProject);
    methods.setValue("projects", nextProject, {
      shouldDirty: hasChanged,
      shouldValidate: true,
    });
  };

  const store = methods.formState.dirtyFields.projects;

  function extractDay(dateString: string | number) {
    if (!dateString) {
      console.warn("Invalid date in extractDay: dateString is empty");
      return new Date().getDate();
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date in extractDay:", dateString);
      return new Date().getDate();
    }
    return date.getDate();
  }

  function extractMonth(dateString: string) {
    if (!dateString) {
      console.warn("Invalid date in extractMonth: dateString is empty");
      return moment().format("MMM");
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date in extractMonth:", dateString);
      return moment().format("MMM");
    }
    return moment(date).format("MMM");
  }

  function extractYear(dateString: string) {
    if (!dateString) {
      console.warn("Invalid date in extractYear: dateString is empty");
      return moment().format("YYYY");
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date in extractYear:", dateString);
      return moment().format("YYYY");
    }
    return moment(date).format("YYYY");
  }

  function updateField({ wholeData, selectedProject, newValues }: any) {
    console.log("wholeData:>> ", wholeData, selectedProject, newValues);

    if (wholeData.data) {
      console.log("condition true :>> update field");
      console.log("===================================" + wholeData.data);
      //  Check Selected Project is there and Filtering the existing Project data
      const selectedItem = wholeData.data.filter((item: any) => {
        return item["projectId"] === selectedProject;
      });

      console.log("selected items : " + selectedItem);
      const taskId = newValues.id;

      if (selectedItem.length) {
        if (selectedItem[0].detail.length > 0) {
          selectedItem[0].detail.length = 0;
          selectedItem[0].detail.push(newValues);
          console.log("New values >>>", newValues);

          return { ...wholeData, data: selectedItem };
        } else {
          selectedItem[0].detail.push(newValues);
          return { ...wholeData, data: selectedItem };
        }
      }
      // condition for Checking Project data is there or not
      else if (!selectedItem.length) {
        console.log("Project not found, adding new project.");
        const newProject = {
          projectId: selectedProject,
          detail: [newValues],
          id: wholeData.data?.[0]?.id || "",
          comment: "",
          status: "InProgress",
          totalHour: newValues.hour,
        };
  
        if (
          wholeData.data &&
          Array.isArray(wholeData.data) &&
          wholeData.data.length > 0
        ) {
          console.log("whole data", wholeData.data);

          wholeData.data.length = 0;

          wholeData.data.push(newProject);

          return { ...wholeData, data: [...wholeData.data] };
        } else {
          wholeData.data = wholeData.data || [];
          wholeData.data.push(newProject);

          return { ...wholeData, data: [...wholeData.data] };
        }
      }
    } else {
      console.log("third condition:>>>>>>>>>>");
      const newWholeData = {
        email: selectedUser,
        status: "InProgress",
        projectIds: `${selectedProject}`,
        comment: "",
        isNew: true,
        data: [
          {
            projectId: selectedProject,
            detail: [newValues],
            comment: "",
            status: "InProgress",
            totalHour: newValues.hour,
          },
        ],
      };
      return newWholeData;
    }
  }

  const getApiMessage = (payload: any, fallback: string) => {
    if (!payload) return fallback;
    if (typeof payload === "string") return payload;
    return payload.message || payload.error || payload.details || fallback;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onSubmit = async (data: any) => {
    console.log("data", data);

    if (!data.date) {
      console.error("Date is required");
      addToast("Date is required", "error");
      return;
    }

    const dateInUtc = inUtc(data.date);
    if (!dateInUtc) {
      console.error("Invalid date conversion");
      addToast("Invalid date", "error");
      return;
    }

    const dateInEpoch = getEpochTime(dateInUtc) * 1000;
    console.log(dateInUtc);
    console.log(dateInEpoch);

    const newValues = {
      id: taskId && taskId.id,
      day: extractDay(dateInUtc),
      task: data.task,
      hour: data.Hours,
      comment: "",
      // date: getEpochTime(data.date),
      date: dateInEpoch,
    };
          console.log("Original project", selectedProj);
console.log("Selected project", selectedProject);
console.log("Task ID", taskId.id);
    const value = updateField({ wholeData, selectedProject, newValues });
    value.month = extractMonth(dateInUtc);
    value.year = extractYear(dateInUtc);
    // On update, preserve all existing projectIds and only add the selected
    // project when it is not already present — never remove an existing id.
    value.projectIds = mergeProjectIds(value.projectIds, selectedProject);
    console.log("value :>>", value);
    if (!value.isNew) {
      console.log("put", value);
      try {
        const res = await apiService.put(`api/timesheet/update/${taskId.id}`, value);
        console.log("res", res);
        addToast(
          getApiMessage(res?.data, "Timesheet updated successfully"),
          "success"
        );
        setRefresh(refresh + 1);
        // Small delay to ensure state updates properly before closing
        setTimeout(() => {
          onClose();
        }, 100);
      } catch (err: any) {
        console.log("err :>> ", err);
        addToast(
          getApiMessage(
            err?.response?.data,
            err?.message || "Failed to update timesheet"
          ),
          "error"
        );
      }
    } else {
      const payloadData: Array<any> = projects.map((project) => {
        const payload: any = {
          projectId: project.projectId,
          projectName: project.name,
          detail: monthData,
          comment: "",
          status: "InProgress",
          totalHour: data.Hours,
        };
        const taskDetails: Array<any> = [];
        // payload.detail = [...taskDetails];
        payload.totalHour = data.Hours;
        return payload;
      });

      const wholeData = {
        email: selectedUser,
        comment: data.task,
        year: year,
        month: month,
        status: "InProgress",
        totalHour: data.Hours,
        submitDate: new Date(),
        projectIds: selectedProject,
        userName: "",
        data: [...payloadData],
      };
      console.log("post :>", wholeData);
      const newValue1 = updateField({ wholeData, selectedProject, newValues });
      console.log("newValue1  post new ==>", newValue1);
      try {
        const res = await apiService.post(`api/timesheet`, value);
        if (res.status === 200) {
          setRefresh(refresh + 1);
          onClose();
          addToast(
            getApiMessage(res?.data, "Timesheet updated successfully"),
            "success"
          );
          console.log("res created:>> ", res);
        } else {
          console.log("error");
          addToast(getApiMessage(res?.data, "Failed to add timesheet"), "error");
        }
      } catch (err: any) {
        console.log("err", err);
        addToast(
          getApiMessage(
            err?.response?.data,
            err?.message || "Failed to add timesheet"
          ),
          "error"
        );
      }
    }
  };

  // const handleTaskChange = (e: any) => {
  //   setTask(e.target.value);
  // };

  const handleDateChange = (e: any) => {
    setDate(e.target.value);
    methods.setValue("date", e.target.value);
  };

  // const handleHoursChange = (e: any) => {
  //   if (e.target.value > 0) {
  //     setHour(e.target.value);
  //   } else {
  //     setHour(0);
  //   }
  // };

  return (
    <div className="space-y-6 md:grid-cols-2">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="grid gap-6 mb-1 md:grid-cols-2">
            <div className="form-group mb-1">
              <label
                htmlFor="project"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select Project <span className="text-red-500"> *</span>
              </label>

              <Select
                name="projects"
                options={projectOptions}
                value={projectOptions.find(
                  (option) => option.value === selectedProject
                )}
                className="select"
                styles={customSelectStyles}
                onChange={handleProjectChange}
                menuPosition="fixed"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              />

              {methods.formState.errors.projects && (
                <span className="text-red-500 text-sm mt-1">
                  {methods.formState.errors.projects.message}
                </span>
              )}
            </div>
            <div className="grid gap-6 mb-1 md:grid-cols-2">
              <div>
                <Input
                  type="date"
                  label="Date"
                  name="Date"
                  onChange={handleDateChange}
                  value={date}
                  disabled
                />
              </div>
              <div>
               <Controller
        name="Hours"
        control={methods.control}
        render={({ field: { onChange, value } }) => (
          <Input
            name="Hours"
            label="Hours"
            type="number"
            placeholder="Eg: 8"
            onChange={onChange}
            value={value ?? ""}
            required
          />
        )}
      />
              </div>
            </div>
          </div>
          <Input
            type="textarea"
            label="Task"
            name="task"
            placeholder="Worked on Sample task"
            required
          />
          {/* <div className="flex justify-end items-center p-4 md:p-5 border-t border-gray-200 rounded-b"> */}
            <button
              type="button"
              onClick={onClose}
              className="ms-3 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={!isDirty || isSubmitting}
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 ms-3 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              Update
            </button>
          {/* </div> */}
        </form>
      </FormProvider>
    </div>
  );
};

export default EditTimeSheet;
